"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ProfileProvider = require("../../../provider/ProfileProvider");

var _ConfigProvider = _interopRequireDefault(require("../../../provider/ConfigProvider"));

var _SelectComponent = _interopRequireDefault(require("../../SelectComponent"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["config", "profile", "specialDefaults"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SingleEditView = function SingleEditView(_ref) {
  var config = _ref.config,
      onPropertySave = _ref.onPropertySave,
      valueName = _ref.valueName,
      btnText = _ref.btnText,
      translationOverride = _ref.translationOverride;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      getPlainProfile = _useContext.getPlainProfile;

  var handlePropertySave = function handlePropertySave(changedValueName) {
    onPropertySave((0, _defineProperty2.default)({}, changedValueName, context[changedValueName].value), getPlainProfile());
  };

  var componentConfiguration = (0, _extends2.default)({}, config.componentConfigurations[valueName], {
    translations: (0, _extends2.default)({}, config.componentConfigurations[valueName].translations, translationOverride)
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectComponent.default, {
      componentConfiguration: componentConfiguration
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      flat: true,
      round: true,
      extraBold: true,
      color: "dark",
      variant: "contained",
      texttransform: "none",
      className: _styleModule.default.saveBtn,
      onClick: function onClick() {
        return handlePropertySave(valueName);
      },
      children: btnText
    })]
  });
};

var SingleEdit = function SingleEdit(_ref2) {
  var config = _ref2.config,
      profile = _ref2.profile,
      specialDefaults = _ref2.specialDefaults,
      props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConfigProvider.default, {
    config: config,
    translateNs: '',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileProvider.ProfileProvider, {
      baseProfile: profile,
      specialDefaults: specialDefaults,
      stateMode: "volatile",
      dataMode: "edit",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SingleEditView, (0, _extends2.default)({
        config: config
      }, props))
    })
  });
};

var _default = SingleEdit;
exports.default = _default;